import "$styles/index.css"
import "$styles/syntax-highlighting.css"

import "./main.js"
import "$javascript/pwa-handler.js"

import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
